<!-- 维修工单 -->
<template>
  <div class="work-order-page">
    <avue-crud ref="crud" v-model="form" :option="option" :table-loading="loading" :data="data" :page.sync="page" :search.sync="query" :defaults.sync="defaults" @row-save="rowSave" @row-update="rowUpdate" @row-del="rowDel"
               @search-change="searchChange" @search-reset="searchReset" @refresh-change="refreshChange" :before-open="beforeOpen" @current-change="currentChange" @size-change="sizeChange" @on-load="onLoad">
      <template slot-scope="{ row }" slot="priority">
        <el-tag :type="priorityType(row.priority)">{{
            priorityText(row.priority)
          }}</el-tag>
      </template>
      <template slot-scope="{ row }" slot="orderStatus">
        <el-tag :type="statusType(row.orderStatus)">{{
            statusText(row.orderStatus)
          }}</el-tag>
      </template>

      <template slot-scope="{ row }" slot="imagePath">
        <el-image v-if="parseImages(row.imagePath).length > 0" v-for="(img, idx) in parseImages(row.imagePath)" :key="idx" :src="img" :preview-src-list="parseImages(row.imagePath)"
                  style="width: 50px; height: 50px; margin-right: 8px; border-radius: 4px;" fit="cover" />
        <span v-else>-</span>
      </template>

      <template slot-scope="{ row }" slot="menu">
        <el-button type="text" size="small" @click="handleView(row)">查看</el-button>
        <el-button type="text" size="small" @click="startHandle(row)" v-if="row.orderStatus === 0">开始处理</el-button>
        <el-button type="text" size="small" @click="finishHandle(row)" v-if="row.orderStatus === 1">完成处理</el-button>
        <el-button type="text" size="small" @click="handlePartRequest(row)" v-if="row.orderStatus === 1">领用备件</el-button>
        <el-button type="text" size="small" @click="acceptPass(row)" v-if="row.orderStatus === 2 && user_id == row.reporterId">验收通过</el-button>
        <el-button type="text" size="small" @click="acceptReject(row)" v-if="row.orderStatus === 2 && user_id == row.reporterId">验收不通过</el-button>
        <el-button type="text" size="small" @click="cancelOrder(row)" v-if="[0].includes(row.orderStatus)">取消</el-button>
      </template>
    </avue-crud>

    <!-- 领用备件弹窗 -->
    <el-dialog title="领用备件" :visible.sync="partRequestVisible" width="600px" :append-to-body="true" :close-on-click-modal="false">
      <el-form :model="partRequestForm" :rules="partRequestRules" ref="partRequestForm" label-width="100px">
        <el-form-item label="工单编号">
          <span>{{ partRequestForm.workOrderId }}</span>
        </el-form-item>
        <el-form-item label="备件" prop="partId">
          <el-select v-model="partRequestForm.partId" placeholder="请选择备件" filterable style="width: 100%" @change="handlePartChange">
            <el-option v-for="item in partList" :key="item.id" :label="item.partName + '(' + item.partCode + ')'" :value="item.id">
              <span style="float: left">{{ item.partName }}</span>
              <span style="float: right; color: #8492a6; font-size: 12px">库存: {{ item.stockCount }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="当前库存">
          <span>{{ selectedPart ? selectedPart.stockCount : '-' }}</span>
        </el-form-item>
        <el-form-item label="申请数量" prop="requestCount">
          <el-input-number v-model="partRequestForm.requestCount" :min="1" :max="selectedPart ? selectedPart.stockCount : 999" style="width: 100%"></el-input-number>
        </el-form-item>
        <el-form-item label="用途" prop="purpose">
          <el-input type="textarea" v-model="partRequestForm.purpose" :rows="3" placeholder="请输入用途说明" maxlength="200" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="partRequestVisible = false">取消</el-button>
        <el-button type="primary" @click="submitPartRequest">提交申请</el-button>
      </span>
    </el-dialog>

    <!-- 工单详情组件 -->
    <work-order-detail :visible.sync="detailVisible" :work-order-id="currentWorkOrderId" :get-detail-api="apiConfig.getDetail" @process="handleDetailProcess" />

    <!-- 取消工单弹窗 -->
    <el-dialog title="取消工单" :visible.sync="cancelDialogVisible" width="500px" :append-to-body="true" :close-on-click-modal="false">
      <el-form :model="cancelForm" :rules="cancelRules" ref="cancelForm" label-width="100px">
        <el-form-item label="工单编号">
          <span>{{ cancelForm.workOrderId }}</span>
        </el-form-item>
        <el-form-item label="取消原因" prop="remark">
          <el-input type="textarea" v-model="cancelForm.remark" :rows="4" placeholder="请输入取消原因" maxlength="200" show-word-limit></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitCancel">确定</el-button>
      </span>
    </el-dialog>
    <dialog-reset title="完成处理" :visible.sync="handleForm" height="auto" width="650px">
      <FinishHandleForm @handleClose="handleClose" :currentRow="currentRow"></FinishHandleForm>
    </dialog-reset>

    <el-dialog title="请输入原因" :visible.sync="reasonDialogVisible" :close-on-click-modal="false" width="400px" :append-to-body="true">
      <el-input type="textarea" rows="3" v-model="reasonValue" placeholder="请输入原因（必填，不超过100字）" maxlength="100" show-word-limit></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="reasonDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleConfirm">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, add, update, remove, getDetail, updateStatus, uploadEndpoint } from "./api";
import { searchTimeConfig } from "@/basic-common/util/common";
import WorkOrderDetail from "./components/WorkOrderDetail.vue";
import validator from '@/util/validate.js'
import FinishHandleForm from "./components/finish-handle-form.vue";
import { getUserInfo } from "@/api/system/user";


export default {
  name: "WorkOrderManagement",
  components: {
    WorkOrderDetail,
    FinishHandleForm
  },
  mixins: [crudMixins],
  data () {
    return {
      apiConfig: { getList, add, update, remove, getDetail },
      user_id: '',
      detailVisible: false,
      handleForm: false,
      reasonDialogVisible: false,
      reasonValue: '',
      currentWorkOrderId: null,
      cancelDialogVisible: false,
      currentRow: {},
      cancelForm: {
        id: null,
        workOrderId: '',
        remark: ''
      },
      cancelRules: {
        remark: [
          { required: true, message: '请输入取消原因', trigger: 'blur' },
          { min: 5, message: '取消原因至少5个字符', trigger: 'blur' }
        ]
      },
      option: {
        ...this.$store.state.publicOption,
        addBtn: true,
        editBtn: false,
        delBtn: false,
        viewBtn: false,
        menu: true,
        dialogWidth: '800px',
        dialogHeight: '70vh',
        column: [
          {
            label: "工单编号",
            prop: "workOrderId",
            search: true,
            addDisplay: false,
            editDisplay: false,
            span: 12,
            width: 160,
          },
          {
            label: "报修人",
            prop: "reporterId",
            type: "select",
            remote: true,
            dicUrl: "/api/produce/base-workorderuser/select/distinct/pycode?realName={{key}}",
            props: { label: "realName", value: "id" },
            search: true,
            rules: [{ required: true, message: "请选择报修人" }],
            dicFormatter: (res) => res.records || [],
            span: 12,
            width: 160,
            change: ({ value, }) => {
              if (value) {
                const arr = this.$refs.crud.DIC.reporterId.filter(ii => ii.id === value)
                this.form.reporterName = arr[0].realName
                this.form.reporterPhone = arr[0].phone
              }
            },
            hide: true,
          },
          {
            label: "报修人",
            prop: "reporterName",
            addDisplay: false,
            editDisplay: false,
            search: false,
          },
          {
            label: "手机号",
            prop: "reporterPhone",
            search: true,
            span: 12,
            width: 160,
            rules: [
              {
                required: true,
                validator: validator.validatorPhone,
                trigger: 'blur',
              },
            ],
          },
          {
            label: "设备",
            prop: "deviceId",
            type: "select",
            remote: true,
            dicUrl: "/api/produce/base-device-manage/select/distinct/pycode?deviceName={{key}}",
            props: { label: "deviceName", value: "id" },
            rules: [{ required: true, message: "请选择设备" }],
            span: 12,
            addDisplay: true,
            editDisplay: false,
            width: 160,
            hide: true,
            change: ({ value, }) => {
              const column = this.findObject(this.option.column, 'faultLocation')
              if (value) {
                const arr = this.$refs.crud.DIC.deviceId.filter(ii => ii.id === value)
                this.form.deviceName = arr[0].deviceName
                this.form.faultLocation = arr[0].deviceLocation
                if (arr[0].deviceLocation) {
                  column.disabled = true
                } else {
                  column.disabled = false
                }
              }
            },
          },
          {
            label: "设备",
            prop: "deviceName",
            overHidden: true,
            addDisplay: false
          },
          {
            label: "故障地点",
            prop: "faultLocation",
            type: "input",
            overHidden: true,
            disabled: true,
            rules: [{ required: true, message: "请输入故障地点" }],
            span: 24,
          },
          {
            label: "优先级",
            prop: "priority",
            type: "select",
            props: { label: "dictValue", value: "dictKey" },
            dicUrl: "/api/blade-system/dict-biz/dictionary?code=priority",
            rules: [{ required: true, message: "请选择优先级" }],
            slot: true,
            align: "center",
            span: 12,
            dataType: 'string',

          },
          {
            label: "负责工程师",
            prop: "responsibleEngineerName",
            span: 12,
            addDisplay: false,
            editDisplay: false
          },

          {
            label: "创建时间",
            prop: "createTime",
            addDisplay: false,
            editDisplay: false,
          },
          // {
          //   label: "处理时间",
          //   prop: "processTime",
          //   type: "datetime",
          //   valueFormat: "yyyy-MM-dd HH:mm:ss",
          //   addDisplay: false,
          //   editDisplay: true,
          //   span: 12,
          // },
          {
            label: "故障描述",
            prop: "faultDescription",
            type: "textarea",
            // addDisplay: false,
            // editDisplay: true,
            span: 24,
            maxlength: 200,
            minRows: 3,
            rules: [{ required: true, message: "请输入" }],
          },
          {
            label: "状态",
            prop: "orderStatus",
            type: "select",
            search: true,
            // dicUrl: "/api/blade-system/dict-biz/dictionary?code= ",
            dicData: this.statusDic(),
            props: { label: "label", value: "value" },
            dataType: "number",
            addDisplay: false,
            editDisplay: false,
            span: 12,
          },
          {
            label: "图片",
            prop: "imagePath",
            type: "upload",
            multiple: true,
            drag: true,
            action: uploadEndpoint,
            propsHttp: { res: "data", url: "link" },
            dataType: "string",
            listType: "picture-card",
            tip: "支持多图上传, 最多可上传5张图片",
            limit: 5,
            slot: true,
            span: 24,
            hide: true
          },
          {
            label: "图片描述",
            prop: "imageDesc",
            type: "textarea",
            addDisplay: true,
            span: 24,
            hide: true
          },
          {
            ...searchTimeConfig,
            paramsKey: ["startTime", "endTime"],
            span: 24,
          },
        ],
      },
      // 领用备件相关
      partRequestVisible: false,
      partList: [],
      selectedPart: null,
      partRequestForm: {
        workOrderId: '',
        partId: '',
        requestCount: 1,
        purpose: ''
      },
      partRequestRules: {
        partId: [{ required: true, message: '请选择备件', trigger: 'change' }],
        requestCount: [{ required: true, message: '请输入申请数量', trigger: 'blur' }],
        purpose: [{ required: true, message: '请输入用途说明', trigger: 'blur' }]
      }
    };
  },
  created() {
    const { userInfo } = this.$store.state.user
    this.user_id = userInfo.user_id
  },
  methods: {
    // 领用备件
    async handlePartRequest(row) {
      this.partRequestForm = {
        workOrderId: row.workOrderId,
        partId: '',
        requestCount: 1,
        purpose: ''
      };
      this.selectedPart = null;
      // 获取备件列表
      try {
        const res = await this.$axios.get('/api/produce/base-spare-part-manage/select/page', {
          params: { current: 1, size: 1000 }
        });
        if (res.data && res.data.success) {
          this.partList = res.data.data.records || [];
        }
      } catch (error) {
        console.error('获取备件列表失败:', error);
      }
      this.partRequestVisible = true;
    },
    handlePartChange(partId) {
      this.selectedPart = this.partList.find(item => item.id === partId);
      this.partRequestForm.requestCount = 1;
    },
    async submitPartRequest() {
      this.$refs.partRequestForm.validate(async (valid) => {
        if (valid) {
          try {
            // 通过API获取当前用户信息
            const userRes = await getUserInfo();
            const userData = userRes.data && userRes.data.data;
            const userId = userData ? (userData.userId || userData.id || userData.user_id) : null;
            const userName = userData ? (userData.realName || userData.name || userData.nick_name) : '';

            const res = await this.$axios.post('/api/produce/base-spare-part-request/add', {
              partId: this.partRequestForm.partId,
              partName: this.selectedPart ? this.selectedPart.partName : '',
              requestCount: this.partRequestForm.requestCount,
              purpose: this.partRequestForm.purpose,
              sourceType: 'repair',
              sourceId: this.partRequestForm.workOrderId,
              applicantId: userId,
              applicantName: userName
            });
            if (res.data && res.data.success) {
              this.$message.success('申请提交成功，等待审批');
              this.partRequestVisible = false;
            } else {
              this.$message.error((res.data && res.data.msg) || '提交失败');
            }
          } catch (error) {
            this.$message.error('提交失败');
          }
        }
      });
    },

    // 工具方法
    priorityText (v) {
      return { 1: "紧急", 2: "一级", 3: "二级", 4: "三级" }[v] || "-";
    },
    priorityType (v) {
      return { 1: "danger", 2: "warning", 3: "warning", 4: "info" }[v] || "info";
    },

    statusDic () {
      return [
        { label: "已发起", value: 0 },
        { label: "处理中", value: 1 },
        { label: "待验收", value: 2 },
        { label: "验收完成", value: 3 },
        { label: "验收未通过", value: 4 },
        { label: "已取消", value: 5 },
      ];
    },
    statusText (v) {
      const item = this.statusDic().find((i) => i.value === v);
      return (item && item.label) || "-";
    },
    statusType (v) {
      return {
        0: "info",
        1: "warning",
        2: "",
        3: "success",
        4: "danger",
        5: "info",
      }[v] || "";
    },
    parseImages (pathStr) {
      if (!pathStr) return [];
      return pathStr.split(",").map((s) => s.trim()).filter(s => s);
    },

    // CRUD 方法
    rowSave (row, done, loading) {

      this.apiConfig.add(row).then(() => {
        this.$message.success("新增成功");
        this.onLoad(this.page);
        done();
      }).catch((error) => {
        console.error('新增失败:', error);
        loading();
      });
    },

    rowUpdate (row, index, done, loading) {
      console.log('rowUpdate - 接收到的row参数:', row);
      console.log('rowUpdate - this.form:', this.form);

      // 使用 row 参数进行更新
      this.apiConfig.update(row).then(() => {
        this.$message.success("更新成功");
        this.onLoad(this.page);
        done();
      }).catch((error) => {
        console.error('更新失败:', error);
        loading();
      });
    },

    rowDel (row) {
      this.$confirm("确定删除该工单吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.apiConfig.remove(row.id).then(() => {
          this.$message.success("删除成功");
          this.onLoad(this.page);
        });
      });
    },

    // 查看详情
    handleView (row) {
      this.currentWorkOrderId = row.id;
      this.detailVisible = true;
    },

    // 详情页面的处理事件
    handleDetailProcess ({ action, data }) {
      console.log('处理操作:', action, data);

      if (action === 'start') {
        // 开始处理
        this.startHandle(data);
      } else if (action === 'finish') {
        // 完成处理
        this.finishHandle(data);
      } else if (action === 'accept') {
        // 验收通过
        this.acceptPass(data);
      }
    },

    // 状态操作方法
    startHandle (row) {
      this.$confirm("确认开始处理该工单吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "info",
      }).then(() => {
        updateStatus({ id: row.id, orderStatus: 1 }).then(() => {
          this.$message.success("操作成功");
          this.onLoad(this.page);
        });
      });
    },

    finishHandle (row) {
      this.currentRow = row
      this.handleForm = true
      //   this.$confirm("确认完成处理该工单吗？", "提示", {
      //     confirmButtonText: "确定",
      //     cancelButtonText: "取消",
      //     type: "info",
      //   }).then(() => {
      //     updateStatus({ id: row.id, orderStatus: 2 }).then(() => {
      //       this.$message.success("操作成功");
      //       this.onLoad(this.page);
      //     });
      //   });
    },

    acceptPass (row) {
      this.$confirm("确认验收通过吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "success",
      }).then(() => {
        updateStatus({ id: row.id, orderStatus: 3 }).then(() => {
          this.$message.success("验收通过");
          this.onLoad(this.page);
        });
      });
    },

    acceptReject (row) {
      this.currentRow = row; // 保存当前行数据
      this.reasonValue = ''; // 清空输入框
      this.reasonDialogVisible = true; // 显示弹窗
    },
    handleConfirm () {
      if (!this.reasonValue) {
        this.$message.error('内容不能为空！');
        return;
      }
      updateStatus({
        id: this.currentRow.id,
        orderStatus: 4,
        remark: this.reasonValue
      }).then(() => {
        this.$message.success("已标记为验收不通过");
        this.onLoad(this.page);
        this.reasonDialogVisible = false; // 关闭弹窗
      });
    },

    cancelOrder (row) {
      // 打开取消弹窗，填写取消原因
      this.cancelForm = {
        id: row.id,
        workOrderId: row.workOrderId,
        remark: ''
      };
      this.cancelDialogVisible = true;
    },

    // 提交取消
    submitCancel () {
      this.$refs.cancelForm.validate((valid) => {
        if (valid) {
          const params = {
            id: this.cancelForm.id,
            orderStatus: 5,
            remark: this.cancelForm.remark
          };

          updateStatus(params).then(() => {
            this.$message.success("工单已取消");
            this.cancelDialogVisible = false;
            this.onLoad(this.page);

            // 重置表单
            this.$refs.cancelForm.resetFields();
          }).catch(() => {
            // 错误已经在axios拦截器中处理
          });
        }
      });
    },
    handleClose (type) {
      this.handleForm = false
      // 保存并关闭后刷新列表
      if (type) {
        this.onLoad(this.page, this.query)
      }
    }
  },
};
</script>

<style lang="scss" scoped>
</style>

